var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-switch',{attrs:{"size":_vm.size || _vm.config.Size,"active-text":_vm.Text,"disabled":_vm.disabled || _vm.config.Disabled},on:{"change":_vm.OnChange},model:{value:(_vm.Data),callback:function ($$v) {_vm.Data=$$v},expression:"Data"}})
}
var staticRenderFns = []

export { render, staticRenderFns }